import { setTriggerEventName } from "components/utils/utils";
import { Trigger } from "../../../types";
import { Field } from "./Form";
import { CustomSchema } from "./types";

export const triggerSchame: CustomSchema<Trigger>[] = [
  {
    name: "name",
    label: "Name",
    component: "input",
    required: true,
    uniqe: true,
    tooltip: "Display name of the trigger"
  },
  {
    name: "triggerScript",
    label: "Trigger Script",
    component: "select",
    selectOptions: "script",
    required: true,
    uniqe: false,
    tooltip: "The script to trigger when the selected event happens."
  },
  {
    name: "eventType",
    label: "Event",
    component: "eventType",
    required: false,
    uniqe: false,
    tooltip: "The event that causes the trigger to run."
  },
  {
    name: "environment",
    label: "Environment",
    component: "environment",
    initialValue: "Default",
    tooltip: "The environment to run the triggered script in."
  },
  {
    name: "computer",
    label: "Run On",
    component: "computer",
    tooltip: "The computer to run this trigger on."
  },
  {
    uniqe: false,
    noStyle: true,
    required: true,
    shouldUpdate: (prevValues, curValues) => {
      return prevValues.eventType !== curValues.eventType;
    },
    children: ({ getFieldValue }) => {
      let selectedEvent = getFieldValue("eventType");
      const eventName = setTriggerEventName(selectedEvent);
      return eventName?.startsWith("ProtectEvent") ? (
        <Field
          component="input"
          name="protectRule"
          label="PowerShell Protect Rule"
          preserve={false}
          tooltip="The trigger will only happen when an event occurs with this PowerShell Protect Rule."
        />
      ) : null;
    },
  },
  {
    uniqe: false,
    noStyle: true,
    required: true,
    shouldUpdate: (prevValues, curValues) => {
      return prevValues.eventType !== curValues.eventType;
    },
    children: ({ getFieldValue }) => {
      let selectedEvent = getFieldValue("eventType");
      const eventName = setTriggerEventName(selectedEvent);
      return eventName?.startsWith("Dashboard") ? (
        <Field
          component="select"
          selectOptions="dashboard"
          name="dashboard"
          label="Dashboard"
          preserve={false}
          tooltip="The trigger will only happen when the event occurs with this dashboard."
        />
      ) : null;
    },
  },
  {
    name: "dashboard",
    hidden: true,
    style: { display: "none" },
  },
  {
    required: true,
    uniqe: false,
    noStyle: true,
    shouldUpdate: (prevValues, curValues) => {
      return prevValues.eventType !== curValues.eventType;
    },
    children: ({ getFieldValue }) => {
      let selectedEvent = getFieldValue("eventType");
      const eventName = setTriggerEventName(selectedEvent);
      return eventName?.startsWith("Job") ? (
        <Field
          component="scriptSelect"
          name="script"
          label="Script"
          preserve={false}
          tooltip="The trigger will only happen when the event occurs with this script."
        />
      ) : null;
    },
  },
  {
    name: "script",
    hidden: true,
    style: { display: "none" },
  },
  {
    name: "delay",
    label: "Delay (Seconds)",
    component: "inputNumber",
    tooltip: "The number of seconds to delay before running the trigger script."
  },
];
